import type { ColumnDefinition } from "./columnDefinition";
import type { FilterCondition, StageCombinator } from "./state";

export type ColumnFiltersAction =
  | SetFilterAction
  | DeleteFilterAction
  | DeleteStageAction
  | SetColumnsAction
  | ClearFiltersAction
  | SetCombinatorAction;

export class SetFilterAction {
  readonly type = "set_filter";
  constructor(
    readonly payload: {
      columnId: string;
      /** When omitted, the stage is appended. */
      stageIndex?: number;
      value: string;
      condition: FilterCondition;
      value2?: string;
    },
  ) {}
}

export class DeleteStageAction {
  readonly type = "delete_stage";
  constructor(
    readonly payload: {
      columnId: string;
      stageIndex: number;
    },
  ) {}
}

export class DeleteFilterAction {
  readonly type = "delete_filter";
  constructor(
    readonly payload: {
      columnId: string;
    },
  ) {}
}

export class SetColumnsAction {
  readonly type = "set_columns";
  constructor(readonly payload: ColumnDefinition[]) {}
}

export class ClearFiltersAction {
  readonly type = "clear_filters";
}

export class SetCombinatorAction {
  readonly type = "set_combinator";
  constructor(
    readonly payload: {
      columnId: string;
      combinator: StageCombinator;
    },
  ) {}
}
